import styles from "./usoCep.module.css";
import api from "../../utils/axios/api";
import formatCEP from "../../utils/misc/formatCep";
import { Dispatch } from "react";

type UsoCepProps = {
  onClose: () => void;
  onCancel?: () => void;
  setCep: Dispatch<string>
};

export default function UsoCep({ onClose, onCancel, setCep }: UsoCepProps) {

  function handleClick() {
    const clientId = localStorage.getItem('clientId')
    api.get(`/address/client/${clientId}`).then((response) => {
      const cep = formatCEP(response.data[0].address.zipCode);
      setCep(cep)
      localStorage.setItem("cep", cep);
      onClose();
    }).catch(() => {
      alert('Erro ao buscar o CEP')
    });
  }

  function handleAnotherCep() {
    if (onCancel) {
      onCancel();
    }
  }

  return (
    <div className={styles.container}>
      <button className={styles.closeButton} onClick={onClose}>x</button>
      <p className={styles.texto}>Deseja usar o mesmo CEP do cadastro?</p>
      <div className={styles.space}>
        <button className={styles.confirm} onClick={handleClick}>Sim</button>
        <button className={styles.cancel} onClick={handleAnotherCep}>
          Utilizar outro CEP
        </button>
        <button className={styles.cancel} onClick={() => {
          setCep('')
          onClose()
        }}>
          Não usar CEP
        </button>
      </div>
    </div>
  );
}
